/*
 * Public API Surface of Copy to Clipboard directive
 */

export * from './copy-to-clipboard.module';
export * from './directives/copy-to-clipboard.directive';
